import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { Typography } from '@mui/material'
import { dateTimeFormats } from '@theme/variables'

export const ProfileUpdateDate = ({ updatedAt }: { updatedAt: string }) => {
  const { t } = useTranslation()
  return (
    <div>
      <Typography fontWeight={500} component="span">
        {`${t(translationKeys.SEARCH_BY_PROFILE_UPDATED)} `}
      </Typography>
      <Typography component="span">{DateTime.fromISO(updatedAt).toFormat(dateTimeFormats.eventDateFormat)}</Typography>
    </div>
  )
}
